import { ChevronLeftIcon, PencilSquareIcon, ArrowsRightLeftIcon } from "@heroicons/react/24/outline";
import { LightBulbIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import BookDetails from "../business/dto/book-details";
import VocabularyDetails from "../business/dto/vocabulary-details";
import IosBottomContext from "../components/ios/IosBottomContext";
import IosListGroup from "../components/ios/IosListGroup";
import IosListGroupItem from "../components/ios/IosListGroupItem";
import IosNavbar from "../components/ios/IosNavbar";
import IosSearch from "../components/ios/IosSearch";
import useData from "../contexts/data-auth";
import { Switch } from "@headlessui/react";

export default function Book() {
  const [search, setSearch] = useState("");
  const [touched, setTouched] = useState(-1);
  const { data } = useData();
  const { bookId } = useParams();

  const [swapLang, setSwapLang] = useState(false); 

  const filter = (vocabularies: VocabularyDetails[]) => {
    return vocabularies.filter(
      (vocabulary: VocabularyDetails) =>
        vocabulary.key.toLowerCase().includes(search.toLowerCase()) ||
        vocabulary.value.toLowerCase().includes(search.toLowerCase())
    );
  };

  const getBook = (): BookDetails => {
    return data.books.find((x) => x.id === bookId);
  };

  return (
    <>
      {getBook() && (
        <IosNavbar
          title={getBook().title}
          leftAction={
            <Link
              to="/books"
              replace={true}
              className="flex items-center ml-[-24px]"
            >
              <ChevronLeftIcon className="h-7 w-7"></ChevronLeftIcon>
              <span className="m-[-4px]">Back</span>
            </Link>
          }
          rightAction={
            <Link to={`/books/${bookId}/edit`} replace={true}>
              Edit
            </Link>
          }
        >
          {
            <IosSearch
              placeholder="Search vocabulary"
              search={search}
              setSearch={setSearch}
            />
          }
        </IosNavbar>
      )}

      <Switch.Group>
        <div className="flex justify-center my-6">
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">DE</span>

            <Switch
              checked={swapLang}
              onChange={setSwapLang}
              className={`${
                swapLang ? "bg-gray-900" : "bg-gray-300"
              } relative inline-flex h-6 w-11 items-center rounded-full transition`}
            >
              <span
                className={`${
                  swapLang ? "translate-x-6" : "translate-x-1"
                } inline-block h-4 w-4 transform rounded-full bg-white transition`}
              />
            </Switch>

            <span className="text-sm text-gray-600">EN</span>

            <ArrowsRightLeftIcon className="h-4 w-4 text-gray-400 ml-1" />
          </div>
        </div>
      </Switch.Group>




      <IosListGroup>
        {React.Children.toArray(
          filter(getBook().vocabularies).map((item) => (
            <IosListGroupItem
              key={item.id}
              // title={item.key}
              // subtitle={item.value}
              title={swapLang ? item.value : item.key}
              subtitle={swapLang ? item.key : item.value}
              iconColor={"bg-amber-500"}
              extra={`Box ${item.box + 1}`}
              to={`/books/${bookId}/vocabularies/${item.id}`}
            />
          ))
        )}
      </IosListGroup>

      <IosBottomContext
        description={`${filter(getBook().vocabularies).length} ${
          filter(getBook().vocabularies).length === 1
            ? "Vocabulary"
            : "Vocabularies"
        }`}
        rightAction={
          <Link to={`/books/${bookId}/new-vocabulary`} replace={true}>
            <PencilSquareIcon className="h-6 w-6" />
          </Link>
        }
      />
    </>
  );
}
